import { render, staticRenderFns } from "./ChatView.vue?vue&type=template&id=e972c66a&scoped=true&"
import script from "./ChatView.vue?vue&type=script&lang=js&"
export * from "./ChatView.vue?vue&type=script&lang=js&"
import style0 from "./ChatView.vue?vue&type=style&index=0&id=e972c66a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e972c66a",
  null
  
)

export default component.exports